import React, { useState } from 'react';
import GetDistrictsRoleBased from '../../Dropdowns/getDistrictsRoleBased';
import GetAfsoRoleBased from '../../Dropdowns/getAfsoRoleBased';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import ShopWiseCardandSaleDetailsExcel from './ShopWiseCardandSaleDetailsExcel';
// import ShopWiseCardandSaleDetailsExcelReport from './ShopWiseCardandSaleDetailsExcelReport';

function ShopwisecardandsaledetailsExcelInt() {

    const [selectedAfso, setSelectedAfso] = useState("0");
    const [selectedDistCode, setSelectedDistCode] = useState(null);
    const [submittedProps, setSubmittedProps] = useState(null);
    const [renderContent, setRenderContent] = useState(false)
    const [loading, setLoading] = useState(false);
    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

const handleSubmit = () => {
            const month = document.getElementById("month")?.value;
        const year = document.getElementById("year")?.value;
    if (month && year && selectedDistCode) {

        setRenderContent(true);
        setSubmittedProps({
            month: month,
            year: year,
            dist_code: selectedDistCode||"0",
            afso_code: selectedAfso || "0"
        });

        // Then show with new data
        setTimeout(() => setRenderContent(true), 0);
    } else {
        alert("Please select Month, Year and District");
    }
}



    return (
        <div>
            <table align="center" width="60%">
                <thead>
                    <tr className='tableheader' >
                        <th colSpan={8}>Shopwise Card and Sale Details</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                                <td>Month</td>
                                <td>
                                    <GetMonths id="month" onLoadingChange={handleLoadingChange} />
                                </td>

                                <td>Year</td>
                                <td>
                                    <GetYears id="year" onLoadingChange={handleLoadingChange} />
                                </td>
                        <td>District</td>
                        <td><GetDistrictsRoleBased onChange={setSelectedDistCode} /></td>
                        <td>Office</td>
                        <td><GetAfsoRoleBased dist_code={selectedDistCode} value={selectedAfso} onChange={setSelectedAfso} /></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={8} align="center">
                            <button className="button button2" onClick={handleSubmit}>
                                Submit
                            </button>&nbsp;
                            <button className="button button2" onClick={() => window.history.back()}>
                                Back
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>


            <br /><br />
            <br />

            {renderContent && (
    <>
        {/* <ShopWiseCardandSaleDetailsExcelReport 
            key={`${selectedDistCode}-${selectedMonth}-${selectedYear}-${selectedAfso}`} 
            {...submittedProps} 
        /> */}
        <ShopWiseCardandSaleDetailsExcel 
            // key={`${selectedDistCode}-${selectedMonth}-${selectedYear}-${selectedAfso}-excel`} 
            {...submittedProps} 
        />
    </>
)}
        </div>
    );
}

export default ShopwisecardandsaledetailsExcelInt;